import { Box, Button, CircularProgress, Typography } from "@mui/material"
import { useNavigate } from "react-router"
import ContractsTable from "./ContractsTable"
import { useGetContractsQuery } from "@store/services/contractService"
import { useMemo } from "react"

export default function Contracts() {
  const { data, isFetching } = useGetContractsQuery({})
  const navigate = useNavigate()

  const onAddClick = () => {
    navigate("/Administration/Contracts/new")
  }

  const cleanedData = useMemo(
    () =>
      data?.items.map((item) => ({
        ...item,
        product_families: item.product_families
          .map((product) => `${product.family} (${product.product})`)
          .join(","),
      })) ?? [],
    [data],
  )

  return (
    <Box className={"admin-contracts"} sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Contracts
      </Typography>
      {isFetching ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 6 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <ContractsTable data={cleanedData} />
          <Box>
            <Button sx={{ mt: 1 }} variant="contained" onClick={onAddClick}>
              Add Contract
            </Button>
          </Box>
        </>
      )}
    </Box>
  )
}
